import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiIconStrip {
    constructor() {

    }

    freeIconStrip() {
    }

    loadIconStrip() {
    }

    setGadgetIconStrip() {
    }
}
